<template>
  <div class="candidates-nav ">
    <div class="candidates-wrapper">
      <v-layout class="candidates-wrapper-nav">
        <nuxt-link
          :to="myBoardUrl"
          class="white--text display-22 text-center no-underline flex"
          :class="disableByPath ? 'nuxt-link-exact-active nuxt-link-active' : '' "
        >
          משרות מותאמות עבורי
        </nuxt-link>

        <nuxt-link
          v-for="tab in tabs"
          :key="tab.id"
          :to="tab.id < 5 ? tab.route : smartLink"
          class="white--text display-22 text-center no-underline flex"
        >
          {{ tab.name }}
        </nuxt-link>
      </v-layout>
    </div>
  </div>
</template>

<script>
import CurrentUser from '@/components/mixins/CurrentUser';
import { isArray } from 'lodash';

export default {
  mixins: [CurrentUser],
  data() {
    return {
      active: 0,
      // myBoardUrl:'/personal/myboard.aspx?agentscodes=',
      tabs: [
        // { id: 1, name: `משרות מותאמות עבורי`, route: `/personal/myboard.aspx?agentscodes=` },
        { id: 2, name: `קבצי קו"ח`, route: `/personal/cvfiles.aspx` },
        { id: 3, name: `משרות שאהבתי`, route: `/myjobs.aspx` },
        { id: 4, name: `משרות שהסרתי`, route: `/personal/removedjobs.aspx` },

        {
          id: 5,
          name: 'הסוכנת החכמה',
          route: '/smartalerts.aspx',
        },
      ],
    };
  },

  computed: {
    disableByPath() {
      const { agentscodes } = this.$route.query;

      if (agentscodes) {
        return true;
      }else{
        return false
      }
    },
    myBoardUrl() {
      if (!isArray(this.ActiveAgents) || !this.ActiveAgents.length) {
        return `/personal/myboard.aspx`;
      } else {
        let agentcode = this.ActiveAgents[0].AgentCode;
        return `/personal/myboard.aspx?agentscodes=${agentcode}`;
      }
    },
    smartLink() {
      if (this.CurrentUser && this.NumberOfAgents.length > 0) {
        return '/personal/smartalertsnotification/';
      } else {
        return '/smartalerts.aspx';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nuxt-link-exact-active {
  border-bottom: 4px solid #3e4a54;
  pointer-events: none;
}

.candidates-nav a {
  text-decoration: none;
  display: flex;
  padding: 5px 0;
  justify-content: center;
  position: relative;
}

.candidates-nav a:not(:last-child):after {
  content: '|';
  position: absolute;
  left: 0;
}

.candidates-nav {
  background-color: $primary;
  overflow-x: auto;
  overflow-y: hidden;
}

.candidates-wrapper {
  width: 140%;
  margin: 0 auto;
  overflow-x: auto;
  overflow-y: hidden;
}

.candidates-wrapper-nav {
  margin: 0 auto;
}

@media only screen and (min-width: 600px) {
  .candidates-wrapper {
    width: 100%;
  }

  .candidates-nav {
    padding: 0 0;
    background-color: $primary;
  }

  .candidates-nav a {
    padding: 10px 0;
  }

  .candidates-wrapper-nav {
    max-width: 1000px;
    margin: 0 auto;
    line-height: 60px;
  }
}
</style>
